/* The .split('@')[0].replace('room', '') is needed because emails can 
 be both mpyadigital.com, mpya.se and 'room' is because for example 
 penelopecrews' email has a room attatched to its name. 
 Yes, this is madness, but at least I didn't cause this madness ;) */
const compareEmailAddresses = (email1, email2) =>
  email1.split('@')[0].replace('room', '') === email2.split('@')[0].replace('room', '');

export default compareEmailAddresses;
